import { TRootState } from 'Redux/Reducers';

export const getOffers = (state: TRootState) => state.payment.offers;
